<script setup>
import {targetActionsMap} from "@/lib/sendYmParams";
</script>

<template>
  <section class="section characteristics" id="SRS">
    <div class="characteristics-wrapper container">
      <div class="characteristics-content">
        <div class="characteristics-filling">
          <div class="characteristics-description">
            <p class="characteristics-description__title">
              Установите МетаВДНХ на компьютер и играйте без ограничений
            </p>
            <p class="characteristics-description__text">
              Вы можете посетить все мероприятия МетаВДНХ без предварительной
              записи, но для этого необходим компьютер со следующими
              техническими характеристиками
            </p>
            <p
              class="characteristics-description__weight characteristics-description__weight--desk">
              Вес файла 100 Гб
            </p>
            <a
              href="https://cdn.metamsk.ru/launcher_setup.exe"
              download="VDNX"
              target="_blank"
              class="link link--desk"
              @click="targetActionsMap.get(31)()"
              >Скачать ПО
              <img
                src="@/assets/new-icons/ArrowRight.svg"
                alt="Скачать ПО"
                class="link__icon"
            /></a>
          </div>
          <div class="characteristics-info">
            <p class="characteristics-info__requirements">
              Минимальные технические требования к ПК
            </p>
            <div class="characteristics-info__element">
              <img
                src="@/assets/new-icons/landing/windows.svg"
                alt="windows"
                class="characteristics-info__icon" />
              <p class="characteristics-info__text">Операционная система</p>
            </div>
            <div class="characteristics-info__border"></div>
            <div class="characteristics-info__element">
              <p class="characteristics-info__title">
                Intel Core i5–7600 <br />
                AMD Ryzen 5 2600<br />или аналогичные
              </p>
              <p class="characteristics-info__text">Процессор</p>
            </div>
            <div class="characteristics-info__border"></div>
            <div
              class="characteristics-info__element characteristics-info__element--big">
              <p class="characteristics-info__title">16 Гб <span>ОЗУ</span></p>
              <p class="characteristics-info__text">Оперативная память</p>
            </div>
            <div class="characteristics-info__border"></div>
            <div class="characteristics-info__element">
              <p class="characteristics-info__title">
                GeForce GTX 1080<br />или аналогичные AMD
              </p>
              <p class="characteristics-info__text">Видеокарта</p>
            </div>
            <div class="characteristics-info__border"></div>
            <div
              class="characteristics-info__element characteristics-info__element--big">
              <p class="characteristics-info__title">100 Гб</p>
              <p class="characteristics-info__text">Место на диске</p>
            </div>
          </div>
          <p
            class="characteristics-description__weight characteristics-description__weight--mob">
            Вес файла 100 Гб
          </p>
          <a
            href="https://cdn.metamsk.ru/launcher_setup.exe"
            download="VDNX"
            target="_blank"
            class="link link--mob"
            @click="targetActionsMap.get(31)()"
            >Скачать ПО
            <img
              src="@/assets/new-icons/ArrowRight.svg"
              alt="Скачать ПО"
              class="link__icon"
          /></a>
        </div>
        <div class="characteristics-recommendation" v-if="false">
          <p class="characteristics-recommendation__title">
            Участвуйте в мероприятиях прямо через веб-браузер на любом
            устройстве:
          </p>
          <p class="characteristics-recommendation__text">
            Участие в мероприятиях доступно на любой платформе и не требует
            установки дополнительных приложений, однако вам нужно забронировать
            дату и время.
          </p>
          <router-link :to="{name: 'mainPage'}" class="link link--desk"
            >Выбрать дату
            <svg
              class="link__icon"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M24.9824 17.2502L18.2324 24.0002L20.0002 25.768L28.8841 16.8841C29.1185 16.6497 29.2502 16.3317 29.2502 16.0002C29.2502 15.6687 29.1185 15.3507 28.8841 15.1163L20.0002 6.23242L18.2324 8.00019L24.9825 14.7502L2.75 14.7502V17.2502L24.9824 17.2502Z"
                fill="#000" />
            </svg>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.link {
  display: inline-flex;
  align-items: center;
  padding: 1.1875rem 2.5rem;
  background: #d72d41;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 140%;
  gap: 0.75rem;
  border-radius: 3.5rem;

  &__icon {
    width: 2rem;
    height: 2rem;
  }

  &--small {
    line-height: 200%;
    padding: 0.5rem 2.75rem;
    font-size: 1rem;
  }

  &--mob {
    display: none;
  }

  @media (max-width: 1100px) {
    padding: 0.8125rem 1.25rem;
    font-size: 1rem;
    line-height: 140%;
    gap: 0.5rem;
    position: relative;
    z-index: 2;

    &__icon {
      width: 1.25rem;
      height: 1.25rem;
    }

    &--desk {
      display: none;
    }

    &--mob {
      display: inline-flex;
    }
  }
}

.characteristics {
  margin-top: 7rem;
  background: linear-gradient(135deg, #fff 0%, #d0ddff 100%);

  @media (max-width: 767px) {
    display: none;
  }

  &-content {
    display: flex;
    gap: 1.5rem;
  }

  &-filling {
    padding: 6rem 3rem 6rem 3rem;
    display: flex;
    flex-direction: row-reverse;
    max-width: 100%;
    width: 100%;
    gap: 1.5rem;
  }

  &-description {
    margin-top: 4rem;
    max-width: 34.12rem;
    padding: 0 3rem;
    width: 100%;

    &__title {
      font-weight: 500;
      font-size: 2rem;
      line-height: 130%;
      letter-spacing: 0.01em;
      color: #000;
    }

    &__text {
      margin-top: 1rem;
      font-weight: 400;
      font-size: 1.12rem;
      line-height: 133%;
      color: #000;
    }

    .link {
      margin-top: 1rem;
      background: #d72d41;
      color: #fff;

      &--mob {
        display: none;
      }
    }

    &__weight {
      margin-top: 6rem;
      font-size: 0.88rem;
      line-height: 130%;
      color: #000;

      &--mob {
        display: none;
      }
    }
  }

  &-info {
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0 2rem;

    &__icon {
      width: 8.25rem;
    }

    &__text {
      font-weight: 400;
      font-size: 1rem;
      line-height: 140%;
      text-align: right;
      color: #697279;
    }

    &__requirements {
      font-weight: 500;
      font-size: 1.5rem;
      line-height: 130%;
      letter-spacing: 0.01em;
      color: #000;
      margin-bottom: 1rem;
    }

    &__title {
      font-weight: 500;
      font-size: 1.12rem;
      line-height: 140%;
      color: #000;

      span {
        font-size: 1rem;
      }
    }

    &__border {
      max-width: 100%;
      width: 100%;
      height: 1px;
      background: #9ba1a5;
    }

    &__element {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;

      &--big {
        padding: 1.5625rem 0;
      }
    }

    &__link {
      display: flex;
      flex-shrink: 0;
      width: 10.875rem;

      &-img {
        width: 100%;
      }
    }
  }

  &-recommendation {
    padding: 4rem 3rem 2rem 3rem;
    max-width: 34.12rem;
    width: 100%;
    background: #f0f2fa;
    border-radius: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;

    &__title {
      font-weight: 500;
      font-size: 2rem;
      line-height: 130%;
      letter-spacing: 0.01em;
      color: #000;
    }

    &__text {
      font-weight: 400;
      font-size: 1.12rem;
      line-height: 133%;
      color: rgba(0, 0, 0, 0.8);
    }

    .link {
      margin-top: auto;
      color: #fff;
      background: #fff;

      &--mob {
        display: none;
      }
    }
  }

  @media (max-width: 1100px) {
    padding: 3.75rem 0 0 0;

    &__title {
      font-size: 2rem;
      line-height: 130%;
    }

    &-content {
      flex-direction: column;
      gap: 1.5rem;
    }

    &-filling {
      flex-direction: column;
      padding: 1rem;
    }

    &-description {
      padding: 0;
      max-width: 100%;

      &__title {
        font-size: 1.5rem;
        line-height: 130%;
        letter-spacing: 0.01em;
      }

      &__text {
        margin-top: 1rem;
        font-size: 1rem;
        line-height: 140%;
      }

      &__weight {
        margin-top: 2rem;
        font-size: 0.88rem;
        line-height: 130%;

        &--desk {
          display: none;
        }

        &--mob {
          display: flex;
        }
      }
    }

    &-info {
      margin-top: 2rem;
      padding: 0;

      &__text {
        font-size: 1rem;
        line-height: 140%;
      }

      &__title {
        font-size: 1.12rem;
        line-height: 140%;
        color: #000;

        span {
          font-size: 1.12rem;
        }
      }

      &__link {
        width: 7.5rem;
      }

      &__element {
        &--big {
          padding: 0;
        }
      }
    }

    .link {
      margin-top: 1rem;
      max-width: 100%;
      width: 100%;
      justify-content: center;
      background: #d72d41;
      color: #fff;

      &--desk {
        display: none;
      }

      &--mob {
        display: flex;
      }
    }

    &-recommendation {
      padding: 1rem;
      max-width: 100%;
      width: 100%;

      &__title {
        font-size: 1.5rem;
        line-height: 130%;
      }

      &__text {
        font-size: 1rem;
        line-height: 140%;
      }

      .link {
        margin-top: 4rem;
        display: flex;
        background: #000;
        color: #fff;
      }
    }
  }
}
</style>
